var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { title: "Dashboard", "icon-class": "mdi mdi-home" }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4 stretch-card grid-margin" }, [
        _c(
          "div",
          { staticClass: "card bg-gradient-danger card-img-holder text-white" },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("img", {
                staticClass: "card-img-absolute",
                attrs: {
                  src: "images/dashboard/circle.svg",
                  alt: "circle-image"
                }
              }),
              _vm._v(" "),
              _c("h4", { staticClass: "font-weight-normal mb-3" }, [
                _vm._v("Member since"),
                _c("i", {
                  staticClass: "mdi mdi-chart-line mdi-24px float-right"
                })
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "mb-5" }, [_vm._v("01.01.2020")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4 stretch-card grid-margin" }, [
        _c(
          "div",
          { staticClass: "card bg-gradient-info card-img-holder text-white" },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("img", {
                staticClass: "card-img-absolute",
                attrs: {
                  src: "images/dashboard/circle.svg",
                  alt: "circle-image"
                }
              }),
              _vm._v(" "),
              _c("h4", { staticClass: "font-weight-normal mb-3" }, [
                _vm._v("Trainings watched "),
                _c("i", { staticClass: "mdi mdi-video mdi-24px float-right" })
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "mb-5" }, [_vm._v("1.354")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4 stretch-card grid-margin" }, [
        _c(
          "div",
          {
            staticClass: "card bg-gradient-success card-img-holder text-white"
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("img", {
                staticClass: "card-img-absolute",
                attrs: {
                  src: "images/dashboard/circle.svg",
                  alt: "circle-image"
                }
              }),
              _vm._v(" "),
              _c("h4", { staticClass: "font-weight-normal mb-3" }, [
                _vm._v("Lorem ipsum "),
                _c("i", { staticClass: "mdi mdi-diamond mdi-24px float-right" })
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "mb-5" }, [_vm._v("24.00")]),
              _vm._v(" "),
              _c("h6", { staticClass: "card-text" }, [
                _vm._v("Increased by 5%")
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 grid-margin stretch-card" }, [
        _c("div", { staticClass: "card shadow-sm" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h4", { staticClass: "card-title" }, [_vm._v("Welcome!")]),
            _vm._v(" "),
            _c("p", { staticClass: "card-description" }, [
              _vm._v(" Get started now.")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }